module.exports = __webpack_public_path__ + "static/img/eisbecher-rot.48815f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisbecher-rot.jpg
// module id = 0b//
// module chunks = 0